import { render, staticRenderFns } from "./ModalAddressForm.vue?vue&type=template&id=206b95e4"
import script from "./ModalAddressForm.vue?vue&type=script&lang=js"
export * from "./ModalAddressForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports